import type {
  CustomerApplicationSourceSummaryContract,
  QuestionnaireSourceRecordArchiveStatus,
  QuestionnaireSourceRecordContract,
} from '@/contracts/customer-application-binding'
import type { CustomerApplication } from '@/lib/business-workflow'

export type SourceArchiveStatusFilter = 'active' | 'archived' | 'all'

export type SourceArchiveOverride = {
  archiveStatus: QuestionnaireSourceRecordArchiveStatus
  archivedAt?: string
}

type ApplicationWithSourceSummary = CustomerApplication & {
  sourceSummary?: CustomerApplicationSourceSummaryContract
}

export function getApplicationSourceSummary(application: CustomerApplication) {
  return (application as ApplicationWithSourceSummary).sourceSummary
}

export function getApplicationSourceRecordId(application: CustomerApplication) {
  return getApplicationSourceSummary(application)?.sourceRecordId
}

export function getApplicationSourceArchiveStatus(
  application: CustomerApplication,
  overrides: Record<string, SourceArchiveOverride> = {},
) {
  const sourceRecordId = getApplicationSourceRecordId(application)
  if (!sourceRecordId) return 'active'
  return (
    overrides[sourceRecordId]?.archiveStatus ??
    getApplicationSourceSummary(application)?.archiveStatus ??
    'active'
  )
}

export function matchesApplicationArchiveStatus(
  application: CustomerApplication,
  archiveStatusFilter: SourceArchiveStatusFilter,
  overrides: Record<string, SourceArchiveOverride> = {},
) {
  if (archiveStatusFilter === 'all') return true
  return getApplicationSourceArchiveStatus(application, overrides) === archiveStatusFilter
}

export function toSourceArchiveOverride(record: QuestionnaireSourceRecordContract) {
  return {
    archiveStatus: record.archiveStatus ?? 'active',
    archivedAt: record.archivedAt,
  } satisfies SourceArchiveOverride
}
